export type DesignServiceRequestType = 'Standard' | 'DesignLive';

export const MERCHANT_SERVICE_CONFIG: Record<DesignServiceRequestType, string> = {
    Standard: 'PRD-Y2AVFIKY',
    DesignLive: 'PRD-AQTKLEUL',
};

export const CARE_MPVID: Record<DesignServiceRequestType, string> = {
    Standard: 'caredesign',
    DesignLive: 'designlive',
};
